/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getMoeActions, { getMoeDataTypes } from '../../redux/moe'
import { Get } from '../../serveur/axios'

function* getMoeSagas() {
    try {
        const res = yield Get('moe/')

        if (res.status === 200) {
            yield all([
                yield put(getMoeActions.getMoeDataSuccess(res.data.data)),
            ])
        } else {
            yield put(getMoeActions.getMoeDataFailure(res.data.data))
        }
    } catch (error) {
        yield put(getMoeActions.getMoeDataFailure(error))
    }
}

export default function* getMoeSaga() {
    yield takeLatest(getMoeDataTypes.GET_MOE_DATA_REQUEST, getMoeSagas)
}
